<template>
  <div class="flex-column">
    <Textarea
      autoResize
      @update:modelValue="emits('update', { text: $event })"
      :modelValue="props.options.text"
      class="form-control m-1"
    />
    <div class="flex-row p-1-b gap-1">
      <ToggleButton
        :modelValue="props.options.markdown"
        @update:modelValue="emits('update', { markdown: $event })"
        on-label="Markdown"
        off-label="Plain Text"
      />
      <ToggleButton
        :modelValue="props.options.preview"
        @update:modelValue="emits('update', { preview: $event })"
        on-label="Preview"
        off-label="Hidden"
      />
    </div>
    <div v-if="props.options.preview && props.options.markdown" v-html="html" />
  </div>
</template>

<script setup lang="ts">
import { marked } from "marked";
import Textarea from "primevue/textarea";
import ToggleButton from "primevue/togglebutton";
import { computed } from "vue";

const props = defineProps({
  options: { type: Object, required: true },
});

const emits = defineEmits(["update"]);
const html = computed(() => marked(props.options.text));
</script>

<style scoped>
.form-control {
  display: block;
  width: 100%;
  place-self: stretch;
  flex: 1 1 auto;
  min-height: 10em;
}
</style>
